export default __webpack_public_path__ + "assets/icons/default-file.6b6d116b.svg";